import { CheckCircleOutline } from '@mui/icons-material'
import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'

export const CheckOutlineCustom = styled(CheckCircleOutline)<IconStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor, disabled }) =>
    cursor && !disabled ? cursor : 'default'};
  color: ${({ colorIcon }) => colorIcon || COLORS.black};
  ${({ disabled }) => disabled && `fill: ${COLORS.gray};`}
`
//cursor: ${({ cursor }) => cursor || 'pointer'};
